// https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/
import { useState, useEffect } from "react";

export const useViewport = () => {
    const isServerSide = typeof window === "undefined";
    const serverSize = 1200;

    const [browserWidth, setWidth] = useState(
        isServerSide ? serverSize : window.innerWidth
    );
    const [browserHeight, setHeight] = useState(
        isServerSide ? serverSize : window.innerHeight
    );

    useEffect(() => {
        const handleWindowResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    return { browserWidth, browserHeight };
};

// TODO: finish this tutorial when we are using 1 App.js for the whole site
